import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerInterceptor } from '@core/interceptors/spinner.interceptor';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { CatalogsModule } from './catalogs/catalogs.module';
import { ConfigurationsModule } from './configurations/configurations.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { FlowsHistoryModule } from './flows-history/flows-history.module';
import { FlowToolsModule } from './flow-tools/flow-tools.module';
import { InvoicesModule } from './invoices/invoices.module';
import { LinesGroupsModule } from './lines-groups/lines-groups.module';
import { ModulesRoutingModule } from './modules-routing.module';
import { ModulesComponent } from './modules.component';
import { ParticipantsModule } from './participants/participants.module';
import { ProgramsModule } from './programs/programs.module';

@NgModule({
  declarations: [ModulesComponent],
  imports: [
    CommonModule,
    ModulesRoutingModule,
    MaterialModule,
    SharedModule,
    LinesGroupsModule,
    ProgramsModule,
    ConfigurationsModule,
    ParticipantsModule,
    DashboardModule,
    InvoicesModule,
    CatalogsModule,
    FlowsHistoryModule,
    FlowToolsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
})
export class ModulesModule {}
